<template>
  <nav-bar title="钢瓶管理人员首页" />
  <Content :bottom="0">
    <div class="item">
      <span>钢瓶管理人员：</span>
      <span>{{ userInfo.nickName }}</span>
    </div>
    <van-cell-group class="group">
      <van-cell title="钢瓶录入" to="/cylinderEntry" is-link />
      <van-cell title="钢瓶关联" to="/cylinderAssociation" is-link />
      <van-cell title="钢瓶启用" to="/openCylinder" is-link />
      <van-cell title="钢瓶组管理" to="/cylinderGroupManagement" is-link />
      <van-cell title="钢瓶退出" to="/cylinderSignOut" is-link />
      <van-cell
        title="钢瓶流通管理"
        to="/cylinderCirculationManagement"
        is-link
      />
      <van-cell title="钢瓶托管管理" to="/cylinderCustodyManagement" is-link />
      <van-cell title="钢瓶风险管理" to="/cylinderRiskManagement" is-link />
      <van-cell
        title="重新关联二维码"
        to="/reassociateCode?method=cylinderPage"
        is-link
      />
    </van-cell-group>
  </Content>
</template>
<script>
import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
  name: 'CylinderManageUserHome', // 钢瓶管理人员首页
  setup() {
    const store = useStore()
    const userInfo = computed(() => store.state.userInfo)
    return {
      userInfo
    }
  }
}
</script>

<style lang="scss" scoped>
.group {
  margin-top: 0px;
}
.item {
  margin: 16px;
  color: #666;
  font-size: 16px;
  span:last-child {
    color: #333;
    font-weight: 600;
  }
}
</style>
